(() => {
  if (window.dsCountdownController) { window.dsCountdownController.init(); return; }
  const instances = new Map();
  const duration = 30 * 60 * 1000;
  function init() {
    for (const [node, stop] of instances) if (!node.isConnected) { stop(); instances.delete(node); }
    document.querySelectorAll('[data-ds-countdown]').forEach(node => {
      if (instances.has(node)) return;
      const end = Date.now() + duration;
      const minutes = node.querySelector('[data-countdown-min]');
      const seconds = node.querySelector('[data-countdown-sec]');
      let timeout;
      let stopped = false;
      const tick = () => {
        if (stopped) return;
        if (!node.isConnected) { stop(); instances.delete(node); return; }
        clearTimeout(timeout);
        const remaining = Math.max(0, Math.min(1800, Math.ceil((end - Date.now()) / 1000)));
        minutes.textContent = String(Math.floor(remaining / 60)).padStart(2, '0');
        seconds.textContent = String(remaining % 60).padStart(2, '0');
        if (!remaining) {
          node.classList.add('is-expired');
          node.querySelector('[data-countdown-note]').textContent = node.dataset.expired;
          document.removeEventListener('visibilitychange', tick);
        } else if (!document.hidden) timeout = setTimeout(tick, 250);
      };
      const stop = () => { stopped = true; clearTimeout(timeout); document.removeEventListener('visibilitychange', tick); };
      instances.set(node, stop);
      document.addEventListener('visibilitychange', tick);
      tick();
    });
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    for (const [node, stop] of instances) if (event.target.contains(node)) { stop(); instances.delete(node); }
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    for (const stop of instances.values()) stop();
    instances.clear();
    init();
  });
  window.dsCountdownController = { init };
  init();
})();
